export default __webpack_public_path__ + "static/media/math-units-blue.bdcda936.svg";